export default "__VITE_ASSET__NaSYVTXJ__"